import React from "react";
import TextBox from "../../Common/TextBox";

type TextBoxVariant = "password" | "text" | "number";

type Props = {
  label: string;
  labelVariant?: "top-down" | "left-right";
  value?: string | number;
  onChange?: (value: string | number) => void;
  name?: string;
  style?: React.CSSProperties;
  variant?: TextBoxVariant;
  isInteger?: boolean;
  labelStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  unit?: string;
  readOnly?:boolean;
  noBorder?:boolean;
  disabled?:boolean;
  textBoxClassName?:string;
  minValueInclusive?: number;
  maxValueInclusive?: number;
};

const ToolsContentTextBox = ({
  disabled = false,
  label,
  value = "",
  name = "",
  onChange = () => {},
  style,
  variant = "text",
  isInteger = false,
  unit,
  labelStyle,
  inputStyle,
  readOnly = false,
  noBorder = false,
  minValueInclusive = undefined,
  maxValueInclusive = undefined,
  labelVariant = "left-right"
}: Props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: labelVariant === "top-down" ? "column" : "row",
        alignItems: labelVariant === "top-down" ? "left" : "center",
        ...style,
      }}
    >
      <label
        style={{
          textAlign: "left",
          flex: 1,
          fontSize: 14,
          opacity: disabled ? 0.5 : 1,
          marginBottom: labelVariant === "top-down" ? 6 : 0,
          ...labelStyle,
        }}
      >
        {label}
      </label>
      <TextBox
        disabled={disabled}
        name={name}
        onChange={onChange}
        value={value}
        isInteger={isInteger}
        variant={variant}
        minValueInclusive = {minValueInclusive}
        maxValueInclusive = {maxValueInclusive}
        readOnly={readOnly}
        style={{
          height: 33,
          background: "#FFFFFF",
          border: noBorder ? "0px": "1px solid #414042",
          padding: "8px 10px",
          flex: 2,
          opacity: disabled ? 0.5 : 1,
          ...inputStyle,
        }}
      />
      {unit && (
        <div
          style={{
            flex: "0 0 auto",
            margin: "0px 5px",
            fontSize: 13,
          }}
        >
          {unit}
        </div>
      )}
    </div>
  );
};

export default ToolsContentTextBox;
